export default function useTimeFormat(timestamp) {
  const date = new Date(timestamp * 1000);

  if (!isNaN(date)) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}.${minutes}`;
  }
}
